export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f45d70f98e65f1e7145143f2469e52bbf848ddf53&name=fetchTypeahead!'